/* Elephant stencil → MBG logo — time-based, not scroll-based. Fires once,
   ~2 seconds after this script runs, regardless of scroll position; never
   re-arms, never alternates back. prefers-reduced-motion doesn't skip the
   swap, only the CSS crossfade animating it (handled entirely in
   mbg-design-system.css.liquid) — the 2-second wait itself is identical
   either way, per the brief ("simply swap after two seconds without
   animated motion"). */
(function () {
  'use strict';

  if (document.body.classList.contains('mbg-logo-revealed')) {
    return;
  }

  var REVEAL_DELAY_MS = 2000;

  var timer = window.setTimeout(function () {
    document.body.classList.add('mbg-logo-revealed');
  }, REVEAL_DELAY_MS);

  window.addEventListener('pagehide', function () {
    window.clearTimeout(timer);
  });
})();
